
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import QuestionGroup from './QuestionGroupComponent.vue'
import QuestionList from './QuestionListComponent.vue'
import { State, Getter, Action, Mutation } from '../store-helper'

@Component({
  components: {
    QuestionGroup,
    QuestionList
  },
})
export default class ExamComponent extends Vue {
  @State confirmSubmit: boolean
  @Action loadData
  @Action finishExam
  @Action cancelSubmit

  public created () {
    this.loadData()
  }
}
